"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfferClientV1 = exports.getOfferClientV0 = exports.revertToOfferV1 = exports.revertToOfferV0 = exports.convertOffersV1 = exports.convertOffersV0 = exports.getOfferStateV0 = void 0;
const escrow_sdk_v0_1 = require("escrow-sdk-v0");
const index_1 = require("../../index");
const types_1 = require("../types");
const consts_1 = require("./consts");
const getOfferStateV0 = (offerState) => {
    const offerKeys = Object.keys(index_1.OfferState);
    const offerKey = offerKeys.find((key) => index_1.OfferState[key] === offerState);
    if (!offerKey) {
        throw new Error("Invalid offer state");
    }
    return index_1.OfferState[offerKey];
};
exports.getOfferStateV0 = getOfferStateV0;
const convertOffersV0 = (offers) => {
    return offers.map((offer) => {
        return Object.assign(Object.assign({}, offer), { version: types_1.Version.V0, bankName: null, accountNumber: null, accountName: null, nonce: null, marketAccount: consts_1.NULL_PUBKEY, configAccount: offer.escrowConfig });
    });
};
exports.convertOffersV0 = convertOffersV0;
const convertOffersV1 = (offers) => {
    return offers.map((offer) => {
        return Object.assign(Object.assign({}, offer), { version: types_1.Version.V1 });
    });
};
exports.convertOffersV1 = convertOffersV1;
const revertToOfferV0 = (offerData) => {
    const { version, bankName, accountName, accountNumber, nonce, marketAccount, configAccount } = offerData, rest = __rest(offerData, ["version", "bankName", "accountName", "accountNumber", "nonce", "marketAccount", "configAccount"]);
    return Object.assign(Object.assign({}, offerData), { escrowConfig: configAccount, configRentVault: consts_1.NULL_PUBKEY, nativeVaultAccount: consts_1.NULL_PUBKEY, tokenVaultAccount: consts_1.NULL_PUBKEY, nativeVaultBump: [] });
};
exports.revertToOfferV0 = revertToOfferV0;
const revertToOfferV1 = (offerData) => {
    const { version } = offerData, rest = __rest(offerData, ["version"]);
    return Object.assign({}, offerData);
};
exports.revertToOfferV1 = revertToOfferV1;
const getOfferClientV0 = (ctx, configId, offerData) => {
    const pda = new escrow_sdk_v0_1.PDA(ctx.program.programId, configId);
    return new escrow_sdk_v0_1.OfferClient(ctx, offerData.pubkey, (0, exports.revertToOfferV0)(offerData), pda, configId);
};
exports.getOfferClientV0 = getOfferClientV0;
const getOfferClientV1 = (ctx, configId, marketId, offerId) => __awaiter(void 0, void 0, void 0, function* () {
    const pda = new index_1.PDA(ctx.program.programId, configId, marketId);
    const client = yield index_1.OfferClient.getOffer(ctx, marketId, configId, offerId);
    return client;
});
exports.getOfferClientV1 = getOfferClientV1;
